import { NavLink } from "react-router";
import PagesList from "../../components/Pages/PagesList";
import { useTrads } from "../../contexts/trads/useTrads";

function Pages(){
  const {translate}=useTrads();
  return (
  <div>
    <nav>
        <NavLink to={`/pages/add`} className="btn btn-primary mt-3">{translate('btn_add')}</NavLink>
    </nav>
    <PagesList   />
  </div>
  );
}
export default Pages;